export default __webpack_public_path__ + "locales/es/ChangeUserStatusDialog.json?hash=e91b0afe4094cec5480b9a5e7a4fdaba";